export const getJsonObjectCachedOrFetch = async (url, cacheKey) => {
    return getCachedOrFetch(() => fetchJsonObject(url), cacheKey);
}

const fetchJsonObject = async (url) => {
    const response = await fetch(url);
    return await response.json();
}

const getCachedOrFetch = async (fetchFromServer, cacheKey) => {
    const lifetimeSeconds = parseInt(process.env.REACT_APP_Cache_Seconds);
    const seconds = Date.now() / 1000;
    const lifetimeToken = Math.floor(seconds / lifetimeSeconds);
    const storedData = localStorage.getItem(cacheKey);
    const storeData = (data) => {
        localStorage.setItem(cacheKey, JSON.stringify({data, lifetimeToken}));
    };
    if (storedData) {
        const parsedData = JSON.parse(storedData);
        if (parsedData.lifetimeToken === lifetimeToken && parsedData.data) {
            return parsedData.data;
        }

        fetchFromServer().then(data => storeData(data));
        return parsedData.data;
    }

    const data = await fetchFromServer();
    storeData(data);
    return data;
}